import React from 'react'
import {Chip, Box} from '@mui/material'

export default function SelectionChips({options = [], selected = [], handleSelectionChange, exclusive = false}) {
  const handleClick = (value) => {
    if (exclusive) {
      handleSelectionChange([value])
      return
    }
    if (selected.includes(value)) {
      handleSelectionChange(selected.filter((v) => v !== value))
    } else {
      handleSelectionChange([...selected, value])
    }
  }

  return (
    <Box sx={{display: 'flex', flexWrap: 'wrap', gap: 1}}>
      {options.map((option) => (
        <Chip
          key={option.value}
          label={option.label}
          onClick={() => handleClick(option.value)}
          color={selected.includes(option.value) ? 'primary' : 'default'}
          variant={selected.includes(option.value) ? 'filled' : 'outlined'}
          size='small'
        />
      ))}
    </Box>
  )
}
